export const LABEL_ADD_EXTERNAL_URL = 'to External URL';
export const LABEL_ADD_HEALTHERA_FEATURE = 'to Healthera Feature';
export const LABEL_ADD_PAGE = 'to Page';
